import {VoteAndCompany} from '@services/model/vote-and-company';
import {MyVotesResource} from '@services/resource/my-votes-resource';

export class Handelspartner {
  constructor(
    public readonly slug: string,
    public readonly vote: boolean,
  ) {}

  public static fromVoteAndCompany(v: VoteAndCompany): Handelspartner {
    const slug = v.company.slug;
    console.assert(Boolean(slug), 'every company that votes should have a slug name');
    const vote = false;
    return new Handelspartner(slug as string, vote);
  }
}

// Caution: When reducing / adding elements here, make sure the layout
// of the votes-panel.component shows all elements in aligned rows (3x3 or 2x4)
export const allHandelspartners = ['kaufland', 'globus', 'dm', 'rossmann', 'rtg', 'bela', 'vmarkt', 'mueller', 'buenting', 'klaas_kock'];

export function votesToHandelspartners(vs: MyVotesResource): Handelspartner[] {
  const handelspartners: Map<string, boolean> = new Map();
  /* fill with false */
  allHandelspartners.forEach((n) => {
    handelspartners.set(n, false);
  });
  vs.votes.forEach((v) => {
    if (v.company.slug && v.vote.verdict > 0) {
      handelspartners.set(v.company.slug, true);
    }
  });
  return Array.from(handelspartners.entries()).map((x) => new Handelspartner(...x));
}
